import localforage from 'localforage'
import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async downloadMenu ({ state, rootGetters, commit }, { version, variation = 'main', overwrite }) {
    const targetVersion = version || state.latestVersions[variation]

    if (state.menuStoreId !== rootGetters.storeId) {
      commit(types.SET_MENU_STORE_ID, rootGetters.storeId)
    }

    // 如果下載過，就不用再下載一次了
    if (overwrite || !state.menus[variation] || !targetVersion || !state.menus[variation][targetVersion]) {
      const menuId = `stores/${rootGetters.storeId}/menus/releases/${variation}/${targetVersion || 'latest'}`
      const menu = overwrite ? (await storeClient.get(menuId)).data : JSON.parse(await localforage.getItem(menuId)) || (await storeClient.get(menuId)).data

      // 如果 targetVersion 沒有值
      // 代表程式需要 latestVersion 但是前端裡面目前找不到值
      // 這個要在 PUSH_MENU 之前就要做，不然有些 plugins 是在 PUSH_MENU 之後就接著做的，會拿不到 latestVersions 的值
      if (!targetVersion) {
        commit(types.SET_LATEST_RECORD, { variation, version: menu.version })
      }

      commit(types.PUSH_MENU, { menu, source: 'server' })
    }
  },
  async getMenuVariations ({ state, rootGetters, commit }) {
    const { data: variations } = await storeClient.get(`/stores/${rootGetters.storeId}/menus/releaseVariations`)
    commit(types.SET_MENU_VARIATIONS, variations)
  },
  resetMenus ({ commit }) {
    commit(types.RESET_MENUS)
  },
  async downloadBusinessHours ({ rootGetters, commit }, menuVariation) {
    const { data: businessHours } = await storeClient.get(`/stores/${rootGetters.storeId}/businessHourSettings/${menuVariation}`)
    commit(types.SET_BUSINESS_HOURS, { menuVariation, businessHours })
  },
  async uploadBusinessHours ({ state, rootGetters, commit }, menuVariation) {
    const { data: businessHours } = await storeClient.put(`/stores/${rootGetters.storeId}/businessHourSettings/${menuVariation}`, state.businessHours[menuVariation])
    commit(types.SET_BUSINESS_HOURS, { menuVariation, businessHours })
    commit(types.SET_BUSINESS_HOUR_DIRTY, { menuVariation, dirty: false })
  },
  createBusinessHour ({ commit }, { menuVariation, weekdayIndex }) {
    commit(types.CREATE_BUSINESS_HOUR, { menuVariation, weekdayIndex })
    commit(types.SET_BUSINESS_HOUR_DIRTY, { menuVariation, dirty: true })
  },
  setBusinessHour ({ commit }, { menuVariation, weekdayIndex, index, interval }) {
    commit(types.SET_BUSINESS_HOUR, { menuVariation, weekdayIndex, index, interval })
    commit(types.SET_BUSINESS_HOUR_DIRTY, { menuVariation, dirty: true })
  },
  deleteBusinessHour ({ commit }, { menuVariation, weekdayIndex, index }) {
    commit(types.DELETE_BUSINESS_HOUR, { menuVariation, weekdayIndex, index })
    commit(types.SET_BUSINESS_HOUR_DIRTY, { menuVariation, dirty: true })
  }
}
